module.exports = {
  Action: {
      reorder: 'Reorder',
      delete: 'Delete'
  },
  Projects: {
      add: 'Neuer Auftrag',
      projectName: 'Patientenname'
  },
  ProjectDetails: {
    attachments: 'Projektdateien (Const.Info/3ox/...)',
    additionalFiles: 'Zusatzdateien',
    shippingType: 'Versandart nach Fertigstellung',
    alertReference: 'Dieses Projekt ist mit einem anderen Projekt verknüpft:',
    statusReview: 'Status: Freigabe',
  },
  OrderDetails: {
    errorCouldNotReorder: 'Reorder failed'
  },
  Dashboard: {
    title: 'Dashboard',
    NewProduction: 'Produktion',
    NewDesignProduction: 'Design & Produktion',
    NewDesign: 'Design-Service',
    CreateNewCase: 'Neuer Auftrag',
    ProductionDescription: 'Übermitteln Sie Ihr fertiges STL-Design. Wir kümmern uns um die Fertigung aus dem gewünschten Material.',
    DesignProductionDescription: 'Übermitteln Sie uns intraorale Scandaten oder senden Sie uns physische Modelle. Unser Zahntechnikerteam kümmert sich um das Design und schick auf Wunsch gern Designvorschläge.',
    DesignDescription: 'Sie benötigen Unterstützung beim Design? Gerne kümmern wir uns um Ihr Anliegen.'
  },
};